import { sentryInstance } from "./sentry";

export const localStorageAPI = {
    set(value){
        var data = JSON.stringify(value);
        try {
            localStorage.setItem(localDataID, data)
        } catch (e) {
            sentryInstance.sendInfoReport("localStorageAPI doesn't work")
        }
    },

    getJson(){
        var data = localStorage.getItem(localDataID) || '{}';
        return JSON.parse(data);
    },

    getString(){
        return localStorage.getItem(localDataID) || '';
    },

    update(data) {
        var oldData = this.getJson();
        this.set({...oldData, ...data});
    },

    remove(){
        localStorage.removeItem(localDataID);
    }
};